/**
 * Reserved for future nav hooks (e.g. feature flags).
 */
export function initComingSoonNavLinks() {}

/**
 * Mobile: hamburger opens a dropdown under the button; Connect stays in the header.
 */
export function initMobileNav() {
  const toggle = document.getElementById("nav-toggle");
  const nav = document.getElementById("site-nav");
  const dropdown = document.getElementById("site-nav-dropdown");
  if (!toggle || !nav || !dropdown) return;

  const mq = window.matchMedia("(max-width: 640px)");

  function syncNavAria() {
    if (!mq.matches) {
      nav.removeAttribute("aria-hidden");
      return;
    }
    const open = document.body.classList.contains("nav-open");
    nav.setAttribute("aria-hidden", open ? "false" : "true");
  }

  function setOpen(open) {
    document.body.classList.toggle("nav-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    syncNavAria();
    if (open && mq.matches) {
      const first = nav.querySelector("a");
      first?.focus({ preventScroll: true });
    }
  }

  function close() {
    setOpen(false);
  }

  toggle.addEventListener("click", (e) => {
    if (!mq.matches) return;
    e.stopPropagation();
    setOpen(!document.body.classList.contains("nav-open"));
  });

  nav.querySelectorAll("a").forEach((a) => {
    a.addEventListener("click", () => {
      if (mq.matches) close();
    });
  });

  document.addEventListener("click", (e) => {
    if (!mq.matches) return;
    if (!document.body.classList.contains("nav-open")) return;
    if (dropdown.contains(e.target)) return;
    close();
  });

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && document.body.classList.contains("nav-open")) {
      e.preventDefault();
      close();
      toggle.focus();
    }
  });

  mq.addEventListener("change", (e) => {
    if (!e.matches) {
      document.body.classList.remove("nav-open");
    }
    syncNavAria();
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "Open menu");
  });

  syncNavAria();
}
